export const initialValues = () => ({
  nameGroup: "",
  description: "",
});
